<template>
  <v-row no-gutters>
    <v-col cols="12" class="mt-8 mx-4 mb-3">
      <custom-date-picker-new
        v-model="localDate"
        format="datetime"
        :key="`date-picker-${qrId}`"
        outlined
        input-class="date-end"
        :qr-id="qrId"
        @input="handleDateChange"
        @close="$emit('close')"
        @submit="$emit('submit')"
      />
    </v-col>
  </v-row>
</template>

<script>
import customDatePickerNew from "./custom-date-picker-new.vue";
export default {
  name: "SetExpireDate",
  components: { customDatePickerNew },
  props: {
    qrId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      localDate: null,
    };
  },
  methods: {
    handleDateChange(val) {
      this.localDate = val;
    },
  },
};
</script>
